module.exports = __webpack_public_path__ + "static/media/voucher-category-voucher.733b776e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/voucher-category-voucher.svg
// module id = 945
// module chunks = 0